﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateCompany = void 0;
const com = require("../../com/tmpls");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const StatePaged_1 = require("../abstracts/StatePaged");
const models_1 = require("../../api/admin/classes/models");
const gs_1 = require("@ivanlog/gs");
const StateCompanies_1 = require("./StateCompanies");
class StateCompany extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageCompany, "Company", true);
        this.page.ctrls.btnSave.onclick = () => this.trySave();
        this.page.ctrls.btnDelete.onclick = () => this.tryDelete();
    }
    start(args) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (args) {
                if (args instanceof models_1.Company)
                    this._company = args;
                else if (args.id) {
                    this._company = yield this.lockgui(this.app.api.admin.directory.getCompany(args.id));
                    if (!this._company)
                        return gs_1.StateRunResultEnum.Failed;
                }
            }
            if (this._company) {
                yield this.page.ctrls.form.fillFormData(this._company, true);
                this.page.ctrls.iName.addClass('no-active');
                this.page.ctrls.iShortName.addClass('no-active');
                this._urlArgs["id"] = this._company.id.toString();
            }
            else {
                this.page.ctrls.btnDelete.hide();
            }
            return _super.start.call(this);
        });
    }
    afterStart() {
        const _super = Object.create(null, {
            afterStart: { get: () => super.afterStart }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.afterStart.call(this);
            if (this._company)
                this.setLabel(this.title + ` #${this._company.id} '${this._company.shortName}'`);
        });
    }
    trySave() {
        return __awaiter(this, void 0, void 0, function* () {
            var data = yield this.page.ctrls.form.getFormData();
            if (!data)
                return;
            const req = new models_1.CompanyRequest(data);
            let company;
            if (this._company) {
                company = yield this.lockgui(this.app.api.admin.directory.updateCompany(this._company.id, req));
                if (!company)
                    return;
                yield new modalCom.DialogOk("Company updated").show();
            }
            else {
                company = yield this.lockgui(this.app.api.admin.directory.createCompany(req));
                if (!company)
                    return;
                yield new modalCom.DialogOk("Company created").show();
                yield gs_1.StateGS.Run(StateCompanies_1.StateCompanies);
            }
        });
    }
    tryDelete() {
        return __awaiter(this, void 0, void 0, function* () {
            const responce = yield this.lockgui(this.app.api.admin.directory.deleteCompany(this._company.id));
            if (!responce)
                return;
            yield new modalCom.DialogOk("Company deleted").show();
            yield gs_1.StateGS.Run(StateCompanies_1.StateCompanies);
        });
    }
}
exports.StateCompany = StateCompany;
StateCompany.StateName = "company";
//# sourceMappingURL=StateComany.js.map